export default __webpack_public_path__ + "static/media/Arch_AWS-Security-Hub_16.a5b2479c.svg";